import { useTheme } from "@/context/ThemeContext";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { Sun, Moon, Contrast, CircleDot, Check } from "lucide-react";

const OPTIONS = [
  { id: "light", label: "Light", icon: Sun },
  { id: "dark", label: "Dark", icon: Moon },
  { id: "hc-light", label: "High-contrast light", icon: Contrast },
  { id: "hc-dark", label: "High-contrast dark", icon: CircleDot },
];

export default function ThemeToggle({ className = "" }) {
  const { theme, setTheme } = useTheme();
  const current = OPTIONS.find((o) => o.id === theme) || OPTIONS[0];
  const Icon = current.icon;

  return (
    <DropdownMenu>
      <TooltipProvider delayDuration={200}>
        <Tooltip>
          <TooltipTrigger asChild>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" size="icon" className={className} aria-label="Change theme" data-testid="theme-toggle">
                <Icon className="h-5 w-5" />
              </Button>
            </DropdownMenuTrigger>
          </TooltipTrigger>
          <TooltipContent data-testid="theme-toggle-tooltip">Theme: {current.label}</TooltipContent>
        </Tooltip>
      </TooltipProvider>
      <DropdownMenuContent align="end" className="w-56">
        <DropdownMenuLabel>Theme</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {OPTIONS.map((o) => (
          <DropdownMenuItem
            key={o.id}
            onClick={() => setTheme(o.id)}
            data-testid={`theme-option-${o.id}`}
            className="cursor-pointer"
          >
            <o.icon className="mr-2 h-4 w-4" />
            <span className="flex-1">{o.label}</span>
            {theme === o.id && <Check className="h-4 w-4 text-primary" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
